export const TEST_TYPES = {
  API: 'tests',
  BROWSER: 'browser-tests'
};
